import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=5f309d4d&scoped=true&"
import script from "./TaskPage.vue?vue&type=script&lang=js&"
export * from "./TaskPage.vue?vue&type=script&lang=js&"
import style0 from "./TaskPage.vue?vue&type=style&index=0&id=5f309d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f309d4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f309d4d')) {
      api.createRecord('5f309d4d', component.options)
    } else {
      api.reload('5f309d4d', component.options)
    }
    module.hot.accept("./TaskPage.vue?vue&type=template&id=5f309d4d&scoped=true&", function () {
      api.rerender('5f309d4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/TaskPage.vue"
export default component.exports